import config from "../config/envConfig";
import { today } from "../manager/dateManager";
import http, { emailHost } from "./httpService";

// cc is list

const email_auth_headers = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${config.emailAuthToken}`,
};

export const sendEmail = async (emailPayload) => {
  return await http.post(
    emailHost,
    {
      senderAddress: "notification@ataimpex.com",
      senderName: "Impex Notifications",
      receiverAddress: emailPayload.receiverAddress,
      cc: emailPayload.cc,
      bcc: emailPayload.bcc,
      receiverName: emailPayload.receiverName,
      subject: emailPayload.subject,
      HTML: emailPayload.HTML,
      attachments: emailPayload.attachments,
      templateId: "2",
      alertTime: today(true),
    },
    {
      headers: email_auth_headers,
    }
  );
};
